(function () {
  if (window.packedCheckoutBound) return;
  window.packedCheckoutBound = true;

  function setButtonLoading(button, isLoading) {
    if (isLoading) {
      if (!button.querySelector('.add-text')) {
        const label = button.textContent.trim();
        button.innerHTML = `<span class="add-text">${label}</span><span class="spinner" aria-hidden="true"></span>`;
      }

      button.classList.add('loading');
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');
      return;
    }

    button.classList.remove('loading');
    button.removeAttribute('aria-disabled');
    button.removeAttribute('aria-busy');
  }

  function resetLoadingButtons() {
    document.querySelectorAll('.packed-checkout-btn.loading').forEach(function (button) {
      setButtonLoading(button, false);
    });
  }

  window.addEventListener('pageshow', resetLoadingButtons);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resetLoadingButtons();
  });

  async function postJson(url, body) {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: body ? JSON.stringify(body) : undefined
    });

    let data = null;
    try {
      data = await response.json();
    } catch (e) {
      data = null;
    }

    if (!response.ok) {
      const message =
        (data && (data.description || data.message)) ||
        'Request failed: ' + url;
      throw new Error(message);
    }

    return data;
  }

  /**
   * Empty line items and strip any previously applied discount codes
   * (cart/clear.js does not remove codes such as LEVELUP).
   */
  async function clearCartAndDiscounts() {
    await postJson('/cart/clear.js');

    // Shopify Cart AJAX: discount: '' removes all applied discount codes
    await postJson('/cart/update.js', { discount: '' });
  }

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('.packed-checkout-btn');

    if (!button || button.classList.contains('loading')) return;

    event.preventDefault();

    const variantId = button.dataset.variantId;
    const sellingPlanId = button.dataset.sellingPlanId;
    const source = button.dataset.source;

    if (!variantId) {
      console.error('Missing variant ID for checkout button');
      return;
    }

    setButtonLoading(button, true);

    try {
      await clearCartAndDiscounts();

      const payload = {
        items: [{
          id: Number(variantId),
          quantity: 1,
          properties: {
            _landing_source: source
          }
        }]
      };

      if (sellingPlanId) {
        payload.items[0].selling_plan = Number(sellingPlanId);
      }

      const addResult = await postJson('/cart/add.js', payload);

      console.log('Add Result:', addResult);

      window.location.href = '/checkout';
    } catch (error) {
      console.error('Checkout error:', error);
      setButtonLoading(button, false);
    }
  });
})();
